import React from 'react';

const CredibilitySection: React.FC = () => {
  const stats = [
    {
      number: '10,000+',
      description: '글로벌 게시물 스캔',
      icon: '📊'
    },
    {
      number: '15개',
      description: '해외 커뮤니티 분석',
      icon: '🌍'
    },
    {
      number: '100+',
      description: '자체 분석 정교화 기능',
      icon: '🤖'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-16">
          매주 <span className="text-yellow-400">이만큼</span> 분석합니다
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-6xl mb-4">{stat.icon}</div>
              <div className="text-5xl font-bold mb-4 text-yellow-400">{stat.number}</div>
              <p className="text-xl text-gray-300">{stat.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            매주 수만 건의 글로벌 AI 커뮤니티 게시물을 분석하여<br />
            정말 중요한 트렌드만을 선별해 전달합니다
          </p>
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
